import { Link } from 'react-router-dom';
import { ReactComponent as ChevronRight } from '../../../assets/icons/chevron-right.svg';
import { API } from '../../../config/API';
import { useTheme } from '../../../hooks/useTheme';
import { paths } from '../../../Router/paths';
export const SectionItem = ({ name }: { name: string }) => {
    const theme = useTheme();
    return (
        <div className="">
            <Link
                to={paths.SECTION(API.getMenuId(), name)}
                className="inline-flex items-center space-x-3"
            >
                <p className="text-brand-black font-bold text-xl">{name}</p>
                <button
                    className="w-8 h-8 rounded-full flex justify-center items-center bg-brand-brown"
                    style={{ backgroundColor: theme.primaryColor }}
                >
                    <ChevronRight
                        className="stroke-current text-[#765836]"
                        style={{ color: theme.requiresWhiteText ? 'white' : undefined }}
                    />
                </button>
            </Link>
        </div>
    );
};
